
/*
    Display of an individual stored phrase for a message,
    with the means to select it for use or to delete/edit it in place
*/

import React, { useState } from "react";

const StoredMessageData = (props) => {

    const [edit, setEdit] = useState(null);
    const [phrase, setPhrase] = useState(props.display);

    const typePhrase = (evt) => {
        setPhrase(evt.target.value);
    }

    const toggleEdit = () => {
        setEdit(!edit);
    }

    const runSelect = () => {
        props.select(phrase);
    }

    const runUpdate = () => {
        console.log("INNER UPDATE", props.display, phrase);
        props.update(props.display, phrase, () => {
            setEdit(false);
        });
    }

    const runDelete = () => {
        console.log("DELETE", props.display);
        props.delete(props.display);
    }

    return (
        <div style={{
            display: "grid",
            gridTemplateColumns: "6fr 1fr 1fr",
            alignItems: "center",
            margin: "4px 0",
            padding: "2px 2px 2px 4px",
            width: "100%"
        }}
            className="data"
            onClick={props.click}
        >
            {
                edit
                ? <>
                    <textarea value={phrase} onChange={typePhrase}></textarea>
                    <div className="option" onClick={runUpdate}>Save</div>
                    <div className="option" onClick={toggleEdit}>Cancel</div>
                </>
                : <>
                    <span onClick={runSelect}>
                        <span>{props.display}</span>
                    </span>
                    <div className="option" onClick={toggleEdit}>Edit</div>
                    <div className="option" onClick={runDelete}>Delete</div>
                </>
            }
        </div>
    )
}

export default StoredMessageData;
